import React, { useRef } from 'react'
import img from '../images/calendly.webp'
import { Link, useParams } from 'react-router-dom'
import { useState, useEffect } from 'react'
import '../App.css';
import '../edit.css';
import Cookies from 'js-cookie';
import img5 from '../images/shutterstock_1039074919.webp'
import logo from '../images/logoPowercard.png'
import sha256 from 'crypto-js/sha256';
import github from '../images/github.png';
import facebook from '../images/facebook.png';
import twitter from '../images/twitter.png'
import instagram from '../images/instagram.png'
import linkdin from '../images/linkdin.png'
import youtube from '../images/youtube.png'
import pinterest from '../images/pinterest.png'
import snapshat from '../images/snapshat.png'
import tiktok from '../images/tiktok.png'
import reddit from '../images/reddit.png'
import whatsapp from '../images/whatsapp.png'
import axios from 'axios';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import About from '../ProfileComponents.js/About';
import Contact from '../ProfileComponents.js/Contact';
import Appoinetement from '../ProfileComponents.js/Appoinetement';
import Images from '../ProfileComponents.js/Images';
import Links from '../ProfileComponents.js/Links';
import Pictures from '../ProfileComponents.js/Pictures';
import Services from '../ProfileComponents.js/Services';
import Socials from '../ProfileComponents.js/Socials';
import Videos from '../ProfileComponents.js/Videos';
import ProfileImg from '../images/ProfileImg.jpg'
import CoverImg from '../images/CoverImg.jpg'
import CoverImgMedical from '../images/medicalepicture.png'
import Schedule from '../ProfileComponents.js/Schedule';
import Cv from '../ProfileComponents.js/Cv';
import jsonData from '../Cities.json';
import ReviewSelection from '../components/ReviewSelection';
import ChangeLanguage from '../translations/ChangeLanguage';
import { getProfileField } from '../translations/profileTranslation';


function ProfilePage() {
    const { i18n } = useTranslation();

    const { t } = useTranslation();

    const apiUrl = process.env.REACT_APP_BACKEND_URL
        ;
    const ImageUrl = process.env.REACT_APP_IMAGES_URL
    const frontEndUrl = process.env.REACT_APP_REACT_URL


    const { encryptedId } = useParams();

    const secretKey = 'vcard-secret-key';
    const encodeUserId = encryptedId;

    const decodedString = atob(encodeUserId);
    const extractedUserId = decodedString.split(secretKey)[0];


    const hashedUserId = sha256((String(extractedUserId)));

    const [InputsErrors, setInputsErrors] = useState([])
    const [PartageInfoContact, setPartageInfoContact] = useState({})

    const [FonctionsValeurs, setFonctionsValeurs] = useState([])

    const [options, setOptions] = useState([])


    useEffect(() => {
        setOptions(jsonData.data)

    }, []);



    const AddingPartageInfo = (e) => {
        return setPartageInfoContact({ ...PartageInfoContact, [e.target.name]: e.target.value, user_id: encryptedId })

    }
    const StorePartageContactInfo = (e) => {
        e.preventDefault()



        axios
            .post(`${apiUrl}/StorePartageContactInfo`, PartageInfoContact, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
            .then(result => {
                if (result.data.success) {
                    setPartageInfoContact('')
                    setDone(!Done)
                    setInputsErrors([])
                    setPartageContact(false)
                    toast.success(result.data.message, {
                        position: toast.POSITION.CENTER
                    });

                }
                else {
                    setInputsErrors(result.data.errors)

                }
            })


    }


    const [visited, setVisited] = useState(false);

    useEffect(() => {
        const trackVisit = async () => {
            try {
                const response = await fetch(`${apiUrl}/trackVisit`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ user_id: encryptedId }),
                });

                if (response.ok) {
                    const data = await response.json();
                    console.log('Visit tracked successfully:', data);
                } else {
                    console.error('Failed to track visit');
                }
            } catch (error) {
                console.error('Error while tracking visit:', error);
            }
        };

        trackVisit();
    }, []);




    const [PicturesContent, setPicturesContent] = useState([])




    const [ColorsNewTheme, setColorsNewTheme] = useState({
        light: [
            { inner_section_backgroud: '#eaedee', css: 'inner_section_backgroud' },
            { section_background: '#ffffff', css: 'section_background' },
            { body_backgroud: '#F5F8F9', css: 'body_backgroud' },
            { text_color: '#000000', css: 'text-color' },
            { gold: '#C8A443', css: 'gold' },
            { border_bottom: '#ca9608', css: 'border-bottom' },
            { text_gold: '#C8A443', css: 'text-gold' },
            { text_color_auth: '#3f3f3f', css: 'text-color-auth' },
            { partage_bg: '#baf7ba', css: 'partage-bg' }
        ],
        dark: [
            { inner_section_backgroud: '#171718', css: 'inner_section_backgroud' },
            { section_background: '#202021', css: 'section_background' },
            { body_backgroud: '#121212', css: 'body_backgroud' },
            { text_color: '#b2b2b2', css: 'text-color' },
            { gold: '#C8A443', css: 'gold' },
            { border_bottom: '#F5F8F9', css: 'border-bottom' },
            { text_gold: '#C8A443', css: 'text-gold' },
            { text_color_auth: '#f0f0f0', css: 'text-color-auth' },
            { partage_bg: '#008000', css: 'partage-bg' }
        ]
    });

    const [SocialsContent, setSocialsContent] = useState([])
    const [serviceContent, setServiceContent] = useState([])
    const [ProfileContent, setProfileContent] = useState([])
    const [LinksContent, setLinksContent] = useState([])
    const [VideosContent, setVideosContent] = useState([])

    const [ImagesContent, setImagesContent] = useState([])
    const [ContactContent, setContactContent] = useState([])
    const [ApointementContent, setApointementContent] = useState([])
    const [aboutContent, setAboutContent] = useState([])
    const [ScheduleContent, setScheduleContent] = useState([])
    const [CvContent, setCvContent] = useState([])




    const [partageContact, setPartageContact] = useState(false)

    let UserToken = Cookies.get('UserSpecialToken');

    const [FindServiceModal, setFindServiceModal] = useState(false)
    const [isLoading, setIsLoading] = useState(true);

    const [FindPictureModal, setFindPictureModal] = useState(false)
    const [FindPictureId, setFindPictureId] = useState(null)


    const [UserStatus, setUserStatus] = useState('')
    const [phoneNumbers, setPhoneNumbers] = useState([])
    const [currentIndex, setCurrentIndex] = useState(0); // Initialize currentIndex with 0

    const goToPrev = () => {
        setCurrentIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : ImagesContent.length - 1));
    };

    const goToNext = () => {
        setCurrentIndex((prevIndex) => (prevIndex < ImagesContent.length - 1 ? prevIndex + 1 : 0));
    };

    useEffect(() => {
        if (FindPictureModal || partageContact) {
            document.body.classList.add('modal-open');
        } else {
            document.body.classList.remove('modal-open');
        }
    }, [FindPictureModal, partageContact]);

    const [themeData, setThemeData] = useState('')

    const [ProfilePhotoContent, setProfilePhotoContent] = useState(null)
    const [CoverPhotoContent, setCoverPhotoContent] = useState(null)

    const [theme, setTheme] = useState('');


    const setDarkMode = () => {
        document.querySelector('body').setAttribute('data-theme', 'dark');
    };

    const setLightMode = () => {
        document.querySelector('body').setAttribute('data-theme', 'light');
    };

    const componentsContent = {
        AboutEdit: aboutContent,
        ContactInfoEdit: ContactContent,
        ServicesEdit: serviceContent,
        SocialMediaEdit: SocialsContent,
        AppoinetementEdit: ApointementContent,
        LinksEdit: LinksContent,
        ImagesEdit: ImagesContent,
        Pictures: PicturesContent,
        Videos: VideosContent,
        ScheduleEdit: ScheduleContent,
        CvEdit: CvContent


    };

    const [components, setComponents] = useState([]);
    const [ToggleFooter, setToggleFooter] = useState()
    const [googleReview, setGoogleReview] = useState(false)
    const [ReviewsParams, setReviewsParams] = useState(false)

    const [GoogleReviewsLink, setGoogleReviewsLink] = useState(null)

    useEffect(() => {
        fetch(`${apiUrl}/GetComponentsOrderProfile`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ user_id: encryptedId }),
        })
            .then((response) => response.json())
            .then((result) => {
                setComponents(result.data);
                setReviewsParams(result.ReviewsParams);
                setGoogleReview(result.GoogleReview);
                setToggleFooter(result.ToggleFooter)
                setGoogleReviewsLink(result.GoogleReviewsLink)

            });
    }, []);




    useEffect(() => {
        fetch(`${apiUrl}/GetThemeDataProfile`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ user_id: encryptedId }),
        })
            .then(response => response.json())
            .then(result => {
                if (result.data === 'dark') {
                    document.querySelector('body').setAttribute('data-theme', 'dark');
                    setTheme('dark');
                } else {
                    document.querySelector('body').setAttribute('data-theme', 'light');
                    setTheme('light');
                }
                document.documentElement.classList.add(`${result.theme}`);
                setThemeData(result.theme)
                setColorsNewTheme(result.NewThemeData)

            });
    }, []);

    const toggleTheme = e => {
        if (e.target.checked) {
            setDarkMode();
            setTheme('dark');
        } else {
            setLightMode();
            setTheme('light');
        }
    };

    useEffect(() => {
        // Apply dynamic CSS when colors are fetched
        if (ColorsNewTheme) {
            const rootStyle = document.documentElement.style;
            const cssText = generateCSS(ColorsNewTheme);
            const styleElement = document.createElement('style');
            styleElement.textContent = cssText;
            document.head.appendChild(styleElement);
        }
    }, [ColorsNewTheme]);

    const generateCSS = (colors) => {
        let css = '';
        colors.dark.forEach(color => {
            css += `:root.theme-personalise [data-theme="dark"]  { --${color.css}: ${color[color.css]}; }\n`;
        });
        colors.light.forEach(color => {
            css += `:root.theme-personalise { --${color.css}: ${color[color.css]}; }\n`;
        });
        return css;
    };



    const socialMediaIcons = [
        { name: 'Facebook', icon: facebook },
        { name: 'Twitter', icon: twitter },
        { name: 'Instagram', icon: instagram },
        { name: 'LinkedIn', icon: linkdin },
        { name: 'YouTube', icon: youtube },
        { name: 'Pinterest', icon: pinterest },
        { name: 'Snapchat', icon: snapshat },
        { name: 'TikTok', icon: tiktok },
        { name: 'Reddit', icon: reddit },
        { name: 'WhatsApp', icon: whatsapp },
        { name: 'GitHub', icon: github },
        // Add more social media icons as needed
    ];

    const [Done, setDone] = useState(false)


    const textRef = useRef(null);

    const [hasProfileImage, setHasProfileImage] = useState(false);

    useEffect(() => {
        setHasProfileImage(ProfilePhotoContent !== null);
    }, [ProfilePhotoContent]);


    useEffect(() => {
        if (FindServiceModal) {
            document.body.classList.add('modal-open');
        } else {
            document.body.classList.remove('modal-open');
        }
    }, [FindServiceModal]);




    useEffect(() => {
        fetch(`${apiUrl}/GetUserStatus`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",


            },
            body: JSON.stringify({ user_id: encryptedId })


        })
            .then(response => response.json())
            .then(result => {

                setUserStatus(result.data)
                setDone(!Done)

            })

    }, [])
    const [LanguageSelected, setLanguageSelected] = useState('fr')


    // useEffect(() => {
    //     fetch(`${apiUrl}/GetLanguageProfile`, {
    //         method: 'POST',
    //         headers: {
    //             'Content-Type': 'application/json',
    //         },
    //         body: JSON.stringify({ user_id: encryptedId }),
    //     })
    //         .then(response => response.json())
    //         .then(result => {
    //             i18n.changeLanguage(result.data);
    //             setLanguageSelected(result.data)
    //         });


    //     fetch(`${apiUrl}/GetAllValeursFonction`, {
    //         headers: {
    //             'Content-Type': 'application/json',
    //         },
    //     })
    //         .then(response => response.json())
    //         .then(result => {
    //             setFonctionsValeurs(result.data)
    //         });
    // }, []);


// Listen for language changes
useEffect(() => {
    const handleLanguageChange = (event) => {
        const newLang = event.detail;
        console.log('Language changed to:', newLang); // Debug log
        setLanguageSelected(newLang);
    };
    
    window.addEventListener('languageChanged', handleLanguageChange);
    
    return () => {
        window.removeEventListener('languageChanged', handleLanguageChange);
    };
}, []);

useEffect(() => {
    // Initialize language from cookie or fetch from API
    const cookieLang = Cookies.get('LanguageSelected');
    
    if (cookieLang) {
        // Use language from cookie first
        i18n.changeLanguage(cookieLang);
        setLanguageSelected(cookieLang);
    }
    
    // Fetch admin's default language (for first-time visitors)
    fetch(`${apiUrl}/GetLanguageProfile`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ user_id: encryptedId }),
    })
        .then(response => response.json())
        .then(result => {
            // Only set if no cookie exists
            if (!cookieLang && result.data) {
                i18n.changeLanguage(result.data);
                setLanguageSelected(result.data);
                Cookies.set('LanguageSelected', result.data, { expires: 30 });
            }
        });

    fetch(`${apiUrl}/GetAllValeursFonction`, {
        headers: {
            'Content-Type': 'application/json',
        },
    })
        .then(response => response.json())
        .then(result => {
            setFonctionsValeurs(result.data)
        });
}, []);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        setIsLoading(true); // Set isLoading to true initially

        try {
            const responses = await Promise.all([
                fetchDataFromAPI('/GetAboutProfile'),
                fetchDataFromAPI('/GetAppoinetementProfile'),
                fetchDataFromAPI('/GetScheduleProfile'),
                fetchDataFromAPI('/GetCvProfile'),
                fetchDataFromAPI('/GetVideosInfoProfile'),
                fetchDataFromAPI('/GetContactProfile'),
                fetchDataFromAPI('/GetImagesProfile'),
                fetchDataFromAPI('/GetPictureInfoProfile'),
                fetchDataFromAPI('/GetLinksProfile'),
                fetchDataFromAPI('/GetProfileProfile'),
                fetchDataFromAPI('/GetUserPhotoProfile'),
                fetchDataFromAPI('/GetCoverPhotoProfile'),
                fetchDataFromAPI('/GetServiceProfile'),
                fetchDataFromAPI('/GetSocialsProfile'),

            ]);

            const data = await Promise.all(responses.map(response => response.json()));

            const [
                aboutProfileData,
                appointmentData,
                scheduleData,
                Cvdata,
                videosData,
                contactData,
                imagesData,
                pictureInfoData,
                linksData,
                profileData,
                userPhotoData,
                coverPhotoData,
                serviceData,
                socialsData,

            ] = data;

            if (aboutProfileData.success) {
                setAboutContent([aboutProfileData.data]);
            }

            if (appointmentData.success) {
                setApointementContent([appointmentData.data]);
            }

            if (scheduleData.success) {
                setScheduleContent(scheduleData.data);
            }
            if (Cvdata.success) {
                setCvContent([Cvdata.data]);
            }

            if (videosData.success) {
                setVideosContent(videosData.data);
            }

            if (contactData.success) {
                setContactContent([contactData.data]);
            }

            if (imagesData.success) {
                setImagesContent(imagesData.data);
            }

            if (pictureInfoData.success) {
                setPicturesContent(pictureInfoData.data);
            }

            if (linksData.success) {
                setLinksContent(linksData.data);
            }

            if (profileData.success) {
                setProfileContent([profileData.data]);
                setPhoneNumbers(profileData.PhoneNumbers)

            }

            if (userPhotoData.success) {
                setProfilePhotoContent(userPhotoData.data);
            }

            if (coverPhotoData.success) {
                setCoverPhotoContent(coverPhotoData.data);
            }

            if (serviceData.success) {
                setServiceContent(serviceData.data);
            }

            if (socialsData.success) {
                setSocialsContent(socialsData.data);
            }


            setIsLoading(false);
        } catch (error) {
            console.error(error);
            setIsLoading(false);
        }
    };

    const fetchDataFromAPI = async (endpoint) => {
        return fetch(`${apiUrl}${endpoint}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ user_id: encryptedId }),
        });
    };


    const fetchImageDataURL = async () => {
        try {
            const response = await fetch(`${apiUrl}/images/${hashedUserId}/${ProfilePhotoContent}`);
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            const data = await response.json();
            return data.imageDataUrl;
        } catch (error) {
            console.error('Error fetching image Data URL:', error);
            return null;
        }
    };


    const makeVCard = async () => {
        const email = ContactContent[0]?.email || '';
        const firstName = getProfileField(ProfileContent[0], 'first_name', LanguageSelected);
        const lastName = getProfileField(ProfileContent[0], 'last_name', LanguageSelected);
        const org = getProfileField(ProfileContent[0], 'company', LanguageSelected);
        const title = getProfileField(ProfileContent[0], 'position', LanguageSelected);
        const address = ContactContent[0]?.location || '';
        const website = ContactContent[0]?.website || '';
        const otherLinks = `${frontEndUrl}/Profile/${encryptedId}`; // Assuming these values are accessible
        const socialMedia = SocialsContent.length > 0 ? SocialsContent.map(item => item) : []; // Assuming these are the social media handles

        const PhoneNumbers = phoneNumbers || [];
        const photoUrl = `${ImageUrl}/${hashedUserId}/${ProfilePhotoContent}`;

        let vCardData = `BEGIN:VCARD\nVERSION:3.0`;

        // Format the name
        if (firstName || lastName) {
            vCardData += `\nN:${lastName};${firstName};;;`;
        }
        if (firstName && lastName) {
            vCardData += `\nFN:${firstName} ${lastName}`;
        } else {
            vCardData += `\nFN:${firstName || lastName}`;
        }
        if (socialMedia && Array.isArray(socialMedia)) {
            socialMedia.forEach((link, index) => {
                vCardData += `\nX-SOCIALPROFILE;PREF=${index};TYPE=${link.nameSocial.toUpperCase()}:${link.url}`;
            });
        }
        // Add other fields
        if (org) vCardData += `\nORG:${org}`;
        if (title) vCardData += `\nTITLE:${title}`;
        if (address) vCardData += `\nADR:${address}`;
        if (email) vCardData += `\nEMAIL:${email}`;
        if (website) vCardData += `\nURL:${website}`;
        if (otherLinks) vCardData += `\nURL:${otherLinks}`;



        // Add phone numbers
        PhoneNumbers.forEach(phoneObj => {
            const { phone, prefixPhone } = phoneObj;
            const formattedPhoneNumber = `${prefixPhone}-${phone}`;
            vCardData += `\nTEL:${formattedPhoneNumber}`;
        });

        // Fetch the image blob
        if (photoUrl) {
            try {
                const response = await fetch(photoUrl);
                const imageBlob = await response.blob();

                // Encode the image blob as base64
                const imageBase64 = await blobToBase64(imageBlob);

                // Add the image base64 directly to the vCard
                vCardData += `\nPHOTO;TYPE=JPEG;ENCODING=b:${imageBase64}`;
            } catch (error) {
                console.error('Error fetching or encoding image:', error);
            }
        }

        vCardData += `\nEND:VCARD`;

        // ... (rest of the code)

        const blob = new Blob([vCardData], { type: 'text/vcard' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `${firstName || ''}_${lastName || ''}.vcf`;
        link.click();
        URL.revokeObjectURL(url);
    };

    // Function to convert Blob to Base64
    const blobToBase64 = (blob) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result.split(',')[1]);
            reader.onerror = (error) => reject(error);
            reader.readAsDataURL(blob);
        });
    };




    const componentsArray = [
        {
            AboutEdit: 'AboutEdit',
            component: About,
            content: aboutContent || null,
            props: {
                aboutContent,
                LanguageSelected,
                t,
            },
        },
        {
            ContactInfoEdit: 'ContactInfoEdit',
            component: Contact,
            content: ContactContent || null,
            props: {
                ContactContent,
                LanguageSelected,
                t,
                phoneNumbers,
                textRef,
            },
        },
        {
            ServicesEdit: 'ServicesEdit',
            component: Services,
            content: serviceContent || null,
            props: {
                serviceContent,
                LanguageSelected,
                t,
                ImageUrl,
                hashedUserId,
                FindServiceModal,
                setFindServiceModal,
                img5,
            },
        },
        {
            SocialMediaEdit: 'SocialMediaEdit',
            component: Socials,
            content: SocialsContent || null,
            props: {
                SocialsContent,
                LanguageSelected,
                t,
                socialMediaIcons,
            },
        },
        {
            AppoinetementEdit: 'AppoinetementEdit',
            component: Appoinetement,
            content: ApointementContent || null,
            props: {
                ApointementContent,
                LanguageSelected,
                t,
                img,
                ProfileContent
            },
        },
        {
            ScheduleEdit: 'ScheduleEdit',
            component: Schedule,
            content: ScheduleContent || null,
            props: {
                ScheduleContent,
                LanguageSelected,
                t,

            },
        },
        {
            CvEdit: 'CvEdit',
            component: Cv,
            content: CvContent || null,
            props: {
                CvContent,
                LanguageSelected,
                t,
                ImageUrl,
                hashedUserId,

            },
        },
        {
            LinksEdit: 'LinksEdit',
            component: Links,
            content: LinksContent || null,
            props: {
                LinksContent,
                LanguageSelected,
                t,
                ImageUrl,
                hashedUserId,
                img5,

            },
        },
        {
            ImagesEdit: 'ImagesEdit',
            component: Images,
            content: ImagesContent || null,
            props: {
                ImagesContent,
                LanguageSelected,
                t,
                currentIndex,
                setCurrentIndex,
                ImageUrl,
                hashedUserId,
                goToPrev,
                goToNext,
            },
        },
        {
            Pictures: 'Pictures',
            component: Pictures,
            content: PicturesContent || null,
            props: {
                PicturesContent,
                LanguageSelected,
                t,
                ImageUrl,
                hashedUserId,
                FindPictureModal,
                setFindPictureModal,
                FindPictureId,
                setFindPictureId,
            },
        },
        {
            Videos: 'Videos',
            component: Videos,
            content: VideosContent || null,
            props: {
                VideosContent,
                LanguageSelected,
                t,
            },
        },
    ];


    const componentsOrder = () => {
        const filteredComponents = components.filter((componentName) => {
            const content = componentsContent[componentName];
            return content[0] !== null && content.length > 0;
        });
        return filteredComponents

    }
    const [isOpenFonction, setIsOpenFonction] = useState(false);
    const [searchTermFonction, setSearchTermFonction] = useState('');
    const toggleDropdownFonction = () => {
        setIsOpenFonction(!isOpenFonction);
    };
    

    const OptionsFonction = FonctionsValeurs
    .filter(valeur =>  valeur.value.toLowerCase().includes(searchTermFonction))
    .map(valeur => ({
      id: valeur.id,
      value: valeur.value
    }));


  const findValuePosition = (id) => {
      const value = FonctionsValeurs.find(valeur => valeur.id === parseInt(id))
      return value?.value || null



  }



    return (
        <>
            {!isLoading ?
                (
                    <div encryptedId='main' className='app-main '>

                        <div className={`${LanguageSelected == 'ar' ? 'rtlDiv' : ''}`}>
                            {/* Preloader */}

                            <main className="main m-2.5">

                                <div className="container pt-2.5 ">

                                    <div className="row sticky-parent">
                                        {/* Sidebar */}

                                        {UserStatus !== 'Disactivated' &&
                                            <>

                                                <aside className="col-12 col-md-12 col-xl-3  -mb-1">

                                                    <div className="relative sections  pb-3.5  rounded-xl sticky-column">

                                                        <div className="dark-mode absolute -top-4 left-2">
                                                            <input
                                                                type="checkbox"
                                                                checked={theme === 'dark'}
                                                                id="darkmode-toggle"
                                                                onChange={toggleTheme}
                                                            />
                                                            <label id="themeLabel" htmlFor="darkmode-toggle">
                                                                <svg version="1.1" className="sun" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 496 496" style={{ enableBackground: 'new 0 0 496 496' }} xmlSpace="preserve">
                                                                    <rect x="152.994" y="58.921" transform="matrix(0.3827 0.9239 -0.9239 0.3827 168.6176 -118.5145)" width="40.001" height={16} />
                                                                    <rect x="46.9" y="164.979" transform="matrix(0.9239 0.3827 -0.3827 0.9239 71.29 -12.4346)" width="40.001" height={16} />
                                                                    <rect x="46.947" y="315.048" transform="matrix(0.9239 -0.3827 0.3827 0.9239 -118.531 50.2116)" width="40.001" height={16} />
                                                                    <rect x="164.966" y="409.112" transform="matrix(-0.9238 -0.3828 0.3828 -0.9238 168.4872 891.7491)" width={16} height="39.999" />
                                                                    <rect x="303.031" y="421.036" transform="matrix(-0.3827 -0.9239 0.9239 -0.3827 50.2758 891.6655)" width="40.001" height={16} />
                                                                    <rect x="409.088" y="315.018" transform="matrix(-0.9239 -0.3827 0.3827 -0.9239 701.898 785.6559)" width="40.001" height={16} />
                                                                    <rect x="409.054" y="165.011" transform="matrix(-0.9239 0.3827 -0.3827 -0.9239 891.6585 168.6574)" width="40.001" height={16} />
                                                                    <rect x="315.001" y="46.895" transform="matrix(0.9238 0.3828 -0.3828 0.9238 50.212 -118.5529)" width={16} height="39.999" />
                                                                    <path d="M248,88c-88.224,0-160,71.776-160,160s71.776,160,160,160s160-71.776,160-160S336.224,88,248,88z M248,392
				c-79.4,0-144-64.6-144-144s64.6-144,144-144s144,64.6,144,144S327.4,392,248,392z" />
                                                                    <rect x={240} width={16} height={72} />
                                                                    <rect x="62.097" y="90.096" transform="matrix(0.7071 0.7071 -0.7071 0.7071 98.0963 -40.6334)" width="71.999" height={16} />
                                                                    <rect y={240} width={72} height={16} />
                                                                    <rect x="90.091" y="361.915" transform="matrix(-0.7071 -0.7071 0.7071 -0.7071 -113.9157 748.643)" width={16} height="71.999" />
                                                                    <rect x={240} y={424} width={16} height={72} />
                                                                    <rect x="361.881" y="389.915" transform="matrix(-0.7071 -0.7071 0.7071 -0.7071 397.8562 960.6281)" width="71.999" height={16} />
                                                                    <rect x={424} y={240} width={72} height={16} />
                                                                    <rect x="389.911" y="62.091" transform="matrix(0.7071 0.7071 -0.7071 0.7071 185.9067 -252.6357)" width={16} height="71.999" />
                                                                </svg>
                                                                <svg version="1.1" className="moon" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 49.739 49.739" style={{ enableBackground: 'new 0 0 49.739 49.739' }} xmlSpace="preserve">
                                                                    <path d="M25.068,48.889c-9.173,0-18.017-5.06-22.396-13.804C-3.373,23.008,1.164,8.467,13.003,1.979l2.061-1.129l-0.615,2.268
 c-1.479,5.459-0.899,11.25,1.633,16.306c2.75,5.493,7.476,9.587,13.305,11.526c5.831,1.939,12.065,1.492,17.559-1.258v0
 c0.25-0.125,0.492-0.258,0.734-0.391l2.061-1.13l-0.585,2.252c-1.863,6.873-6.577,12.639-12.933,15.822
 C32.639,48.039,28.825,48.888,25.068,48.889z M12.002,4.936c-9.413,6.428-12.756,18.837-7.54,29.253
 c5.678,11.34,19.522,15.945,30.864,10.268c5.154-2.582,9.136-7.012,11.181-12.357c-5.632,2.427-11.882,2.702-17.752,0.748
 c-6.337-2.108-11.473-6.557-14.463-12.528C11.899,15.541,11.11,10.16,12.002,4.936z" /></svg>
                                                            </label>
                                                        </div>
                                                        <div id='profileImage' className="cover_image  ">
                                                            <img className="cover  rounded-t-xl w-full h-full " src={CoverPhotoContent ? `${ImageUrl}/${hashedUserId}/${CoverPhotoContent}` : CoverImg} alt />
                                                        </div>

              <ChangeLanguage />

                                                        <div className='flex justify-center   '>
                                                            <img className="z-20  profile_photo  cover w-full h-full " src={ProfilePhotoContent ? `${ImageUrl}/${hashedUserId}/${ProfilePhotoContent}` : ProfileImg} alt />

                                                        </div>


                                                        <div className="text-center m-3 pb-3">
                                                            {ProfileContent != null &&
                                                                <>
                                                                    <h3 className="title title--h3  sidebar__user-name text-theme  pb-1"><span className="weight--500">{getProfileField(ProfileContent[0], 'first_name', LanguageSelected)}</span> {getProfileField(ProfileContent[0], 'last_name', LanguageSelected)}</h3>

                                                                    {ProfileContent[0]?.position != null &&

                                                                        <div className="div-sections rounded-xl flex-wrap items-center justify-center p-1">
                                                                            <p className='text-theme font-semibold text-2xl'>{getProfileField(ProfileContent[0], 'position', LanguageSelected)}</p>
                                                                            <p className='text-theme text-about text-xl'>{getProfileField(ProfileContent[0], 'company', LanguageSelected)}</p>

                                                                        </div>
                                                                    }
                                                                </>
                                                            }
                                                            <div className='relative flex mt-5 ml-2.5 mr-2.5 items-center justify-center gap-3'>
                                                                {phoneNumbers &&
                                                                    <a onClick={makeVCard} className="btn-review  flex justify-center items-center" href="#">{t("Ajouter aux Contacts")}</a>

                                                                }
                                                                <a onClick={() => setPartageContact(true)} className="btn-review   flex justify-center items-center" href="#">{t("Partager Votre Contact")}</a>



                                                            </div>
                                                            <div className='relative flex mt-3 ml-2.5 mr-2.5 items-center justify-center gap-3'>
                                                                {ReviewsParams &&
                                                                    <ReviewSelection hashedId={encryptedId} LanguageSelected={LanguageSelected} />

                                                                }
                                                                {googleReview &&
                                                                    <a href={GoogleReviewsLink} target='_blank' className="btn-review  flex justify-center items-center gap-2 w-full " >



                                                                        <a>
                                                                                                                                     </a>
                                                                        <p>
                                                                            {t("Google Reviews")}
                                                                        </p>
                                                                    </a>

                                                                }

                                                            </div>


                                                        </div>

                                                        {partageContact &&

                                                            <div>

                                                                <div className="minscreen h-full animated  overflow-auto fadeIn faster  fixed  left-0 top-0 flex justify-center items-center inset-0 z-1000 forms-info overflow">
                                                                    <div className="absolute top-0 right-0 p-4">
                                                                        <a className='w-12 h-12' onClick={() => { setPartageContact(false); setInputsErrors([]) }}>
                                                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-theme  cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                                                                                <path fillRule="evenodd" d="M14.707 14.707a1 1 0 0 1-1.414 0L10 11.414l-3.293 3.293a1 1 0 1 1-1.414-1.414L8.586 10l-3.293-3.293a1 1 0 0 1 1.414-1.414L10 8.586l3.293-3.293a1 1 0 0 1 1.414 1.414L11.414 10l3.293 3.293a1 1 0 0 1 0 1.414z" />
                                                                            </svg>
                                                                        </a>
                                                                    </div>
                                                                    <div className="w-full max-w-sm mt-12 p-8 text-about rounded-md">
                                                                        <h2 className="text-3xl text-theme mb-2">{t("Partage de contact")}</h2>
                                                                        <h2 className="text-2xl text-about  mb-6">{t("Complétez les informations de votre contact")}
                                                                        </h2>
                                                                        <form className="space-y-6">
                                                                            <div className="flex gap-3">
                                                                                <div>
                                                                                    <div className="mt-4">
                                                                                        <input onChange={(e) => AddingPartageInfo(e)} type="text" id="firstName" name="firstName" className="appearance-none block placeholder-sm w-full px-3 py-2 bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black  focus:outline-none active  sm:text-sm" placeholder={t("Prenom")} required />
                                                                                        <p className="mt-2  text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('firstName') && InputsErrors.firstName}</span></p>

                                                                                    </div>
                                                                                </div>
                                                                                <div>
                                                                                    <div className="mt-4">
                                                                                        <input onChange={(e) => AddingPartageInfo(e)} type="text" id="lastName" name="lastName" className="appearance-none block w-full placeholder-sm px-3 py-2 bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black focus:outline-none active  sm:text-sm" placeholder={t("Nom")} required />
                                                                                        <p className="mt-2  text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('lastName') && InputsErrors.lastName}</span></p>

                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div>
                                                                                <div className="mt-4">
                                                                                    <input onChange={(e) => AddingPartageInfo(e)} type="email" id="email" name="email" className="appearance-none block w-full placeholder-sm px-3 py-2 bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black focus:outline-none active sm:text-sm" placeholder={t("Email")} required />
                                                                                    <p className="mt-2  text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('email') && InputsErrors.email}</span></p>

                                                                                </div>
                                                                            </div>
                                                                            <div>
                                                                                <div className="mt-4">
                                                                                    <input onChange={(e) => AddingPartageInfo(e)} type="text" id="company" name="company" className="appearance-none block w-full placeholder-sm px-3 py-2 bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black focus:outline-none active sm:text-sm" placeholder={t("Nom d'entreprise")} required />
                                                                                    <p className="mt-2  text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('company') && InputsErrors.company}</span></p>

                                                                                </div>
                                                                            </div>
                                                                            <div className='relative'>
                                                                                <div
                                                                                    id="dropdown-a-event"
                                                                                    className="relative block w-full placeholder-sm px-3 py-2 sections border border-transparent rounded placeholder-gray-111     sm:text-sm"
                                                                                >
                                                                                    <a onClick={toggleDropdownFonction} className="mr-2 text-theme">{PartageInfoContact.position ? findValuePosition(PartageInfoContact.position) : t('Poste')}</a>
                                                                                    {PartageInfoContact.position &&
                                                                                        <a href="#" onClick={() => AddingPartageInfo({target : {name : 'position' , value : null}})} >
                                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class={`lucide ${LanguageSelected == 'ar' ? 'left-10' : 'right-10 '} rounded-full p-1 div-sections cursor-pointer top-4 text-theme absolute lucide-x`}><path d="M18 6 6 18" /><path d="m6 6 12 12" /></svg>
                                                                                        </a>
                                                                                    }

                                                                                    <svg onClick={toggleDropdownFonction} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class={`lucide  ${LanguageSelected == 'ar' ? 'left-3 ' : 'right-3 '} top-4 text-theme absolute lucide-chevron-down`}><path d="m6 9 6 6 6-6" /></svg>

                                                                                </div>
                                                                                <div id="dropdown-menu-event" className={`absolute z-50 w-full h-72 overflow-y-auto right-0 mt-2 rounded-md shadow-lg sections  p-1 space-y-1 ${isOpenFonction ? '' : 'hidden'}`}>
                                                                                    <input
                                                                                        id="search-input-event"
                                                                                        className="appearance-none block w-full placeholder-sm px-3 py-2 div-sections border border-transparent rounded placeholder-gray-111 text-black focus:outline-none  sm:text-sm"
                                                                                        type="text"
                                                                                        placeholder={t("Search ...")}
                                                                                        value={searchTermFonction}
                                                                                        onChange={(e) => setSearchTermFonction(e.target.value)}
                                                                                        autoComplete="off"
                                                                                    />
                                                                                    {OptionsFonction && OptionsFonction.map(item => (
                                                                                        <a
                                                                                            href="#"
                                                                                            onClick={() => {AddingPartageInfo({target : {name : 'position' , value : item.id} }) ; toggleDropdownFonction()}}
                                                                                            className="block px-4 py-2 text-theme  cursor-pointer rounded-md"
                                                                                            key={item.id}
                                                                                        >
                                                                                            {item.value}
                                                                                        </a>
                                                                                    ))}
                                                                                    {InputsErrors.hasOwnProperty('position') && <p className="mt-2 text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.position}</span></p>}
                                                                                </div>
                                                                            </div>
                                                                        


                                                                            <div className="flex items-center gap-2 ">
                                                                                <div className="inline-block">

                                                                                    <select onChange={(e) => AddingPartageInfo(e)} name='prefixPhone' className=" block  h-14  px-3 py-2 bg-gray-700   rounded   focus:outline-none active  w-24  " style={{ fontSize: '15px', fontWeight: 600 }}>
                                                                                        <option disabled selected>{t("Prefix")}</option>
                                                                                        {options.map((option) => (
                                                                                            <option key={option.prefix} value={option.prefix}>
                                                                                                {`${option.prefix} ${option.country}`}
                                                                                            </option>
                                                                                        ))}
                                                                                    </select>
                                                                                </div>
                                                                                
                                                                                <div className='inline-block mt-2'>
                                                                                    <div className="w-full">
                                                                                        <input onChange={(e) => AddingPartageInfo(e)} type="number" id="phone" name="phone" className="appearance-none  w-full placeholder-sm px-3 py-2 bg-gray-700 border border-transparent rounded placeholder-gray-111 text-black focus:outline-none active  sm:text-sm" placeholder={t("Numero de telephone")} required />
                                                                                        <p className="mt-2  text-red-600 dark:text-red-500"><span className="font-xsmall">{InputsErrors.hasOwnProperty('phone') && InputsErrors.phone}</span></p>

                                                                                    </div>
                                                                                </div>
                                                                            </div>


                                                                            <div>


                                                                                <button onClick={(e) => StorePartageContactInfo(e)} type="submit" className="w-full btn-edit ">
                                                                                    {t("enregistrer")}
                                                                                </button>
                                                                            </div>
                                                                        </form>
                                                                    </div>
                                                                </div>
                                                            </div>


                                                        }
                                                        <div>
                                                            {


                                                                componentsOrder().map((componentName, index) => {
                                                                    const componentData = componentsArray.find(
                                                                        (component) => component[componentName] === componentName
                                                                    );

                                                                    const Component = componentData.component;
                                                                    const divstyle = index % 2 === 0 ? 'div-sections' : 'sections';

                                                                    return (
                                                                        <div key={index} className={divstyle}>
                                                                            <Component divstyle={divstyle} {...componentData.props} />
                                                                        </div>
                                                                    );
                                                                })}
                                                        </div>












                                                    </div>
                                                </aside>


                                                {/* Content */}
                                                <div className={`col-12 col-md-12 col-xl-9 mt-4 `}>
                                                    <section className="footer_Profile ">
                                                        <div className=" p-5 w-full  rounded-xl sections">
                                                            <div className="pb-2">
                                                                {
                                                                    parseInt(ToggleFooter) === 1 &&
                                                                    <h1 className={`${LanguageSelected == 'ar' ? 'title title--h1 first-title title__separate text-theme right-1' : 'title left-0 title--h1 first-title title__separate text-theme'}`}>PowerCard</h1>

                                                                }
                                                            </div>
                                                            {ProfileContent != '' && parseInt(ToggleFooter) === 1 &&
                                                                <p className={`text-theme text-left text-about-footer ${LanguageSelected == 'ar' ? 'rtlDiv' : ''}`}>{getProfileField(ProfileContent[0], 'first_name', LanguageSelected)} {t("et des milliers d'autres professionnels utilisent Powercard au quotidien pour rester en contact avec les personnes qu'ils rencontrent.")}</p>

                                                            }



                                                            <div className={`${parseInt(ToggleFooter) !== 1 ? 'grid grid-cols-1 gap-4 mt-6' : 'grid grid-cols-2 gap-4 mt-6'}`}>
                                                                {parseInt(ToggleFooter) === 1 &&
                                                                    <a className="btn-footer font-semibold" href="https://www.getpowercard.com/" target="_blank">{t("Obtenir mon PowerCard")}</a>

                                                                }

                                                                {UserToken == null ?
                                                                    <Link className="btn-footer" to='/Login'>{t("Se connecter")}</Link>

                                                                    :
                                                                    <Link className="btn-footer" to='/ProfileEdit'>{t("Modifier Profile")}</Link>

                                                                }
                                                            </div>
                                                            <div className="text flex-wrap font-semibold items-center justify-center ml-5 mr-2 mt-5">
                                                                <p className="block text-center text-theme text-sm">
                                                                    Copyright © 2023 | Edited By <a href="https://www.syspower.ma " className="text-theme">SYSPOWER</a>
                                                                </p>
                                                                <p className="block text-center text-theme text-sm">All Rights Reserved</p>
                                                            </div>
                                                        </div>
                                                    </section>
                                                </div>
                                            </>
                                        }
                                    </div>
                                </div>
                            </main>
                            <div className="back-to-top" />

                        </div >
                    </div >

                ) :

                (
                    <div className='flex items-center justify-center h-screen'>
                        <div className='zoom-animation'>
                            <img src={logo} className='w-64' />

                        </div>
                    </div>
                )

            }

        </>

    )
}

export default ProfilePage